import { DeactivatableButton } from '@folio/components';
import { useAssertedParams } from '@folio/lib';
import { useQuery } from '@tanstack/react-query';
import {
  brokerageFirmControllerGetBrokerageFirmQueryOptions,
  keyValueFieldsToObject,
  useInvitationControllerBrokerInvite,
  type BrokerInviteBody,
} from 'korint-sdk';

export function IntermediaryDetailsHeaderRight() {
  const { brokerageFirmId } = useAssertedParams();

  const { mutateAsync: inviteBroker, isPending: isInviteBrokerPending } =
    useInvitationControllerBrokerInvite();

  const { data: contactInfo } = useQuery({
    ...brokerageFirmControllerGetBrokerageFirmQueryOptions(brokerageFirmId),
    select: data => keyValueFieldsToObject(data.customFields ?? []),
  });

  const { contactEmail, contactFirstName, contactLastName } = contactInfo ?? {};

  return (
    <div className="flex items-center">
      <DeactivatableButton
        rules={[
          {
            isValid: Boolean(contactEmail),
            message: "L'adresse mail de contact est obligatoire pour envoyer en signature",
          },
          {
            isValid: Boolean(contactFirstName),
            message: 'Le prénom de contact est obligatoire pour envoyer en signature',
          },
          {
            isValid: Boolean(contactLastName),
            message: 'Le nom de contact est obligatoire pour envoyer en signature',
          },
        ]}
        size="sm"
        isLoading={isInviteBrokerPending}
        onClick={() =>
          inviteBroker({
            data: {
              brokerRole: 'RETAIL_ADMIN',
              brokerageFirmId,
              email: contactEmail as string,
              firstName: contactFirstName as string,
              lastName: contactLastName as string,
            } satisfies BrokerInviteBody,
          })
        }
      >
        Envoi en signature
      </DeactivatableButton>
    </div>
  );
}
